import { FrequencyUnits } from '@kcftech/prometheus-client';
import { SelectedSeriesPoint } from 'pages/workbench/types';
import { MarkerInfo } from 'pages/workbench/workbench_tabs/trend/types';

export const selectedSeriesPointAreEqual = (
    point1: SelectedSeriesPoint | undefined,
    point2: SelectedSeriesPoint | undefined,
) =>
    (point1 === undefined && point2 === undefined) ||
    (point1?.seriesId === point2?.seriesId && point1?.xValue === point2?.xValue);

export function getMarkerFrequencyForUnit(
    markerInfo: MarkerInfo,
    runningSpeedUnit: FrequencyUnits,
) {
    switch (runningSpeedUnit) {
        case FrequencyUnits.Hertz:
            return markerInfo.frequencyHz;
        case FrequencyUnits.CPM:
            return markerInfo.frequencyCpm;
        case FrequencyUnits.Order:
            return markerInfo.frequencyOrders;
        default:
            throw new Error(`Invalid runningSpeedUnit: ${runningSpeedUnit}`);
    }
}

const ValuePrecision = 4;
export const roundToPrecision = (value: number) =>
    Number(value.toPrecision(ValuePrecision));
